import React from 'react';

interface Icon3DEfficiencyProps {
  size?: string;
}

const Icon3DEfficiency: React.FC<Icon3DEfficiencyProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'flow-activity 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(79, 70, 229, 0.3))' }}>
          <defs>
            <linearGradient id="efficiencyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4f46e5" />
              <stop offset="50%" stopColor="#6366f1" />
              <stop offset="100%" stopColor="#4338ca" />
            </linearGradient>
          </defs>
          <polyline points="3,12 7,8 11,14 15,9 21,15" stroke="url(#efficiencyGradient)" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="21" cy="15" r="1.5" fill="url(#efficiencyGradient)" />
          <circle cx="3" cy="12" r="1.5" fill="url(#efficiencyGradient)" opacity="0.6" />
        </svg>
        <style>{`
          @keyframes flow-activity {
            0%, 100% { transform: rotateY(0deg) translateY(0px); }
            50% { transform: rotateY(15deg) translateY(-2px); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DEfficiency;
